import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  [ORDER_FULFILLMENT_STATUSES.REJECTED]: 'Cancelled',
  [ORDER_FULFILLMENT_STATUSES.CREATED]: 'Received',
  [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: 'Confirmed',
  [ORDER_FULFILLMENT_STATUSES.PREPARING]: 'Preparing your order',
  [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: 'Your order is on its way',
  [ORDER_FULFILLMENT_STATUSES.READY]: 'Ready',
  status: {
    actual: 'Current',
    pending: 'Pending',
  },
  warning_label: {
    pickup_time_changed: '{{company}} changed the time from {{initialTime}} to {{currentTime}}',
  },
  labels: {
    order_number: 'Order No: {{number}}',
  },
};
